import HttpClient from 'circe/Http/HttpClient';
import { getSelectedProfileFromStorage } from 'domain/fuse/auth/profiles/utils';
import { show as showNotification, hide as hideNotification } from 'circe/notifications/actions';

const clientErrorHandler = (e) => {
  if (e && e.message && window.store && window.store.dispatch) {
    setTimeout(() => {
      const { notifications } = window.store.getState().circe;
      Object.entries(notifications).forEach(([id, { type }]) => {
        if (type === 'error') {
          window.store.dispatch(hideNotification(id));
        }
      });
      window.store.dispatch(showNotification(e.message, 'error'));
    }, 10);
  }
};

export const authClient = new HttpClient()
  .withBaseURL(AUTH_EDGE)
  .withClientErrorHandler(clientErrorHandler);
export const onboardingClient = new HttpClient().withBaseURL(ONBOARDING_EDGE);

export const shippingClient = new HttpClient()
  .withBaseURL(SHIPPING_EDGE)
  .withBeforeHook((options) => {
    options.headers = {
      Authorization: `Bearer ${getSelectedProfileFromStorage().token}`,
    };
    return options;
  })
  .withClientErrorHandler(clientErrorHandler);

export const operatorClient = new HttpClient()
  .withBaseURL(OPERATIONS_EDGE)
  .withBeforeHook((options) => {
    options.headers = {
      Authorization: `Bearer ${getSelectedProfileFromStorage().token}`,
    };
    return options;
  })
  .withClientErrorHandler(clientErrorHandler);
export const operatorClientWithLang = new HttpClient()
  .withBaseURL(OPERATIONS_EDGE)
  .withBeforeHook((options) => {
    options.headers = {
      Authorization: `Bearer ${getSelectedProfileFromStorage().token}`,
      lang: localStorage.getItem('localeForApi') || 'ar',
    };
    return options;
  })
  .withClientErrorHandler(clientErrorHandler);
export const operatorClientWithoutErrors = new HttpClient()
  .withBaseURL(OPERATIONS_EDGE)
  .withBeforeHook((options) => {
    options.headers = {
      Authorization: `Bearer ${getSelectedProfileFromStorage().token}`,
    };
    return options;
  });
export const reportingClient = new HttpClient()
  .withBaseURL(REPORTING_EDGE)
  .withBeforeHook((options) => {
    options.headers = {
      Authorization: `Bearer ${getSelectedProfileFromStorage().token}`,
    };
    return options;
  })
  .withClientErrorHandler(clientErrorHandler);

export const mockClient = new HttpClient()
  .withBaseURL('https://4998fa81-c909-4cb4-9b48-866e4a8c9c8a.mock.pstmn.io')
  .withBeforeHook((options) => {
    options.headers = {
      Authorization: `Bearer ${getSelectedProfileFromStorage().token}`,
    };
    return options;
  })
  .withClientErrorHandler(clientErrorHandler);

export const strapiClient = new HttpClient().withBaseURL(STRAPI_ENDPOINT);
